module.exports = __webpack_public_path__ + "img/service_franchised.b7d3ed63.jpg";